export const _testimonials = [
    {
      id: 1,
      name: 'Herr Korkmaz',
      review: 'Besonders gut war der direkte Kontakt zu den Projektverantwortlichen, wodurch auch Rückfragen umgehend beantwortet wurden.',
      role: 'eiscaferimini.de',
      ratingNumber: 5,
    },
    {
      id: 2,
      name: 'Herr Orak',
      review: 'Hier wird Kundenorientierung groß geschrieben. Auch die Zusammenarbeit mit weiteren Dienstleistern verlief absolut reibungslos.',
      role: 'Pizza Pasta Sardegna',
      ratingNumber: 5,
    },
    {
      id: 3,
      name: 'Herr Sangüder',
      review: 'Unkomplizierte Zusammenarbeit mit Zebra360 Team bei der Gestaltung und Einführung unserer Website. Vom Logo-Design bis zum Launch war der Projektleiter immer hilfsbereit.',
      role: 'Classic-Company.de',
      ratingNumber: 5,
    },
  ];

  